import {Component, Injectable} from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
    styles: [require('../shared/section/section.component.scss'), require('./education-page.component.scss')]
})
@Injectable()
export class EducationPageComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/education-page.component.ts